/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetMyReservationInvoicePdfPathParameters } from 'api/actions/get-my-reservation-invoice-pdf/get-my-reservation-invoice-pdf-path-parameters';
import { GetMyReservationInvoicePdfResponse } from 'api/actions/get-my-reservation-invoice-pdf/get-my-reservation-invoice-pdf-response';

type GetMyReservationInvoicePdfQueryParameters = Record<string, any>;

/**
 * The path of the GetMyReservationInvoicePdf action.
 */
export const getMyReservationInvoicePdfActionPath = new SweetPath<keyof GetMyReservationInvoicePdfPathParameters>(
  '/reservations/invoices/{invoiceId}/pdf',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetMyReservationInvoicePdf actions.
 */
export default function createGetMyReservationInvoicePdfAction(axios: AxiosInstance) {
  return function getMyReservationInvoicePdfAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetMyReservationInvoicePdfPathParameters;
    query?: GetMyReservationInvoicePdfQueryParameters;
  }) {
    const path = getMyReservationInvoicePdfActionPath.insert(parameters);

    return axios.get<GetMyReservationInvoicePdfResponse, GetMyReservationInvoicePdfResponse>(path, {
      params: query,
      headers,
      responseType: 'blob',
    });
  };
}
